module.exports = __webpack_public_path__ + "img/null_photo.20bfb705.svg";